import {useState} from "react";
import {getProfitReport} from "../../api/Api";
import {Button, Card, DatePicker, Row, Col, Divider} from "antd";
import {InvoiceTable} from "./InvoiceTable";
import {clampToCents, fixedToDisplayUnit} from "../../util/unitutils";
import {CategoryType} from "../../api/Constants";

export const ProfitReport = ({refresh, onRefresh, onApiFail}) => {
    const [startDate, setStartDate] = useState(undefined);
    const [endDate, setEndDate] = useState(undefined);
    const [invoices, setInvoices] = useState([]);
    const [report, setReport] = useState(0);
    const [disable, setDisable] = useState(false);
    const [numReports, setNumReports] = useState(0);

    const onStartDateChange = (date, dateString) => {
        setStartDate(dateString);
    }

    const onEndDateChange = (date, dateString) => {
        setEndDate(dateString);
    }

    const runReport = () => {
        setDisable(true);
        getProfitReport(startDate, endDate).then(result => {
            console.log(JSON.stringify(result));
            let revSum = 0;
            let costSum = 0;

            const r = result.invoices;
            r.forEach(inv => {
                const {amountPaid} = inv;
                revSum += amountPaid;
                let invoiceCost = 0;
                inv.lineItems.forEach(line => {
                    const rawCost = parseFloat(line.cost);
                    let unitCost;
                    if ((line.category === CategoryType.Wholesale) && (line.bulkCost !== null) && (line.bulkCost !== undefined)) {
                        unitCost = line.bulkCost;
                    } else {
                        const displayStartQuantity = fixedToDisplayUnit(line.startQuantity, line.unit);
                        unitCost = rawCost / displayStartQuantity;
                    }
                    const displayQuantity = fixedToDisplayUnit(line.quantity, line.unit);
                    const totalCost = displayQuantity * unitCost;
                    invoiceCost += totalCost;
                });
                inv.totalCost = clampToCents(invoiceCost)
                costSum += invoiceCost;
                inv.key = inv.id;
            });
            setInvoices(r);
            const metrics = {};
            metrics.revenue = clampToCents(revSum);
            metrics.cost = clampToCents(costSum);
            metrics.profit = clampToCents(metrics.revenue - metrics.cost);
            metrics.margin = (metrics.profit * 100 / metrics.cost).toFixed(2)
            const {expenses} = result;
            let expenseSum = 0;
            expenses.forEach(ex => {
                expenseSum += parseFloat(ex.amount);
            })
            metrics.numExpenses = expenses.length;
            metrics.totalExpense = clampToCents(expenseSum);
            metrics.profitWithExpense = clampToCents(metrics.profit + expenseSum);
            metrics.marginWithExpense = (metrics.profitWithExpense * 100 / metrics.cost).toFixed(2);

            const {nonInvoicePayments} = result;
            let paymentSum = 0;
            nonInvoicePayments.forEach(p => {
                paymentSum += parseFloat(p.amount);
            })
            metrics.numPayments = nonInvoicePayments.length;
            metrics.paymentSum = clampToCents(paymentSum);

            setReport(metrics);
            setNumReports(numReports + 1);
        }).catch(e => {

        }).finally(() => {
            setDisable(false);
        });
    }

    return <div>
        <Card style={{textAlign: 'left', margin: "5px"}} title={"Run Profit Report"}>
            <Row style={{margin: '10px'}}>
                <Col style={{marginTop: '5px', width: '80px'}}><b>Start Date: </b></Col>
                <Col><DatePicker onChange={onStartDateChange} /></Col>
            </Row>
            <Row style={{margin: '10px'}}>
                <Col style={{marginTop: '5px', width: '80px'}}><b>End Date: </b></Col>
                <Col><DatePicker onChange={onEndDateChange} /></Col>
            </Row>
            <Button onClick={runReport} disabled={disable}>Run</Button>
        </Card>

        {invoices.length > 0  && <Card size="small" title={`Report for ${startDate} to ${endDate}`} style={{textAlign: 'left',  margin: "5px"}}>
            Total Invoices: {invoices.length} <br/>
            Revenue: $ {report.revenue} <br/>
            Cost: $ {report.cost} <br/>
            Profit: $ {report.profit} <br/>
            Margin: {report.margin} %<br/>
            <Divider />
            Number of Expenses: {report.numExpenses} <br/>
            Total Expenses: $ {report.totalExpense.toFixed(2)} <br />
            Profit (with Expense): $ {report.profitWithExpense} <br />
            Margin (with Expense): {report.marginWithExpense} % <br />
            <Divider />
            Other Payments (non-invoice): {report.numPayments} <br/>
            Total Payments: $ {report.paymentSum} <br/>
        </Card>
        }
        {invoices.length > 0 && <Card size={"small"} title={"Invoices"} style={{textAlign: 'left', margin: "5px"}}>
            <InvoiceTable invoice={invoices} />
        </Card>
        }
        {(invoices.length === 0) && (numReports > 0) &&
            <div style={{color: "red"}}>No invoices match in date range.</div>
        }
    </div>
}